// extracted by mini-css-extract-plugin
export default {"button-primary":"ButtonPrimary_button-primary__cqEfl","button-submit-landing":"ButtonPrimary_button-submit-landing__1R8dk","button-login":"ButtonPrimary_button-login__On63j"};